import React from 'react';

import { type ViewType } from '../ViewToggle';

import { GridContainer, ListContainer } from './components';

export interface ResultsGridProps<T> {
  results: T[];
  viewType?: ViewType;
  renderCard: (item: T, index: number) => React.ReactNode;
  getKey: (item: T, index: number) => string | number;
}

export const ResultsGrid = <T,>({
  results,
  viewType = 'grid',
  renderCard,
  getKey,
}: ResultsGridProps<T>): React.ReactElement | null => {
  if (!results || results.length === 0) {
    return null;
  }

  const Container = viewType === 'grid' ? GridContainer : ListContainer;

  return (
    <Container>
      {results.map((item, index) => (
        <React.Fragment key={getKey(item, index)}>
          {renderCard(item, index)}
        </React.Fragment>
      ))}
    </Container>
  );
};
